
import Search from '@/components/Search.vue'
import { useToogle } from '@/hooks/commons'
import { groups } from '@/config'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

export default {
  name: 'NavBar',
  components: { Search },
  setup() {
    const [mobileMenuShown, toggleMobileMenu] = useToogle()
    const route = useRoute()

    const links = computed(() => [
      {
        text: 'Tous',
        to: { query: { } },
        active: !route.query.group,
      },
      ...groups.map(({ shortTitle, key }) => ({
        text: shortTitle,
        to: { query: { group: key } },
        active: key === route.query.group,
      })),
    ])

    return {
      mobileMenuShown,
      toggleMobileMenu,
      links,
    }
  },
}
